
import allcomp from "../Images/AllCampanies.svg"
import "./Spanish.css"
function LearningSectionSpanish (){
    return(
        <>
<div className="containerofclassa">
    
<div className="Course_include forlarger"  >
                    <div className="courseltitle" >
                    Qué va a aprender
                    </div>
                    <div className="coverspanish">
                       <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Curso teórico de ELDT
                 </div>
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Entrenamiento para su permiso de CDL
                 </div> 
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Entrenamiento para la inspección Pre-trip
                 </div>
                 
                    </div>
               
                 


                </div>
                <div className="Course_include forsmaller"  >
                    <div className="courseltitle" >
                    Qué va a aprender
                    </div>
                    <div className="coverspanish">
                       <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Curso teórico de ELDT
                 </div>
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Entrenamiento para su permiso de CDL
                 </div>  
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
  <path d="M10.75 6.5L7.08125 10L5.25 8.25" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8 14C11.3137 14 14 11.3137 14 8C14 4.68629 11.3137 2 8 2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14Z" stroke="#2C292A" stroke-opacity="0.7" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Entrenamiento para la inspección Pre-trip
                 </div>
                  
                    </div>
               
                 


                </div>
                <div className="Course_include forlarger"  >
                    <div className="courseltitle" >
                    Qué va a aprender
                    </div>
                    <div className="coverspanish">
                       <div className="fortextinsider">
                       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 13.75C13.4518 13.75 16.25 10.9518 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 10.9518 6.54822 13.75 10 13.75Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 11.25C12.0711 11.25 13.75 9.57107 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 9.57107 7.92893 11.25 10 11.25Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.75 12.5V18.75L10 16.875L6.25 18.75V12.5" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>Carga instantánea al Portal TPR
                 </div>
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#6B6969" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.1875 9.375C7.70527 9.375 8.125 8.95527 8.125 8.4375C8.125 7.91973 7.70527 7.5 7.1875 7.5C6.66973 7.5 6.25 7.91973 6.25 8.4375C6.25 8.95527 6.66973 9.375 7.1875 9.375Z" fill="#6B6969"/>
  <path d="M12.8125 9.375C13.3303 9.375 13.75 8.95527 13.75 8.4375C13.75 7.91973 13.3303 7.5 12.8125 7.5C12.2947 7.5 11.875 7.91973 11.875 8.4375C11.875 8.95527 12.2947 9.375 12.8125 9.375Z" fill="#6B6969"/>
  <path d="M13.25 11.875C12.9196 12.4442 12.4455 12.9167 11.8751 13.2451C11.3048 13.5735 10.6582 13.7464 10 13.7464C9.34184 13.7464 8.69523 13.5735 8.12486 13.2451C7.5545 12.9167 7.0804 12.4442 6.75 11.875" stroke="#6B6969" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Pase su CDL rápidamente ¡GARANTIZADO!
                 </div> 
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M16.25 3.125H3.75C3.40482 3.125 3.125 3.40482 3.125 3.75V16.25C3.125 16.5952 3.40482 16.875 3.75 16.875H16.25C16.5952 16.875 16.875 16.5952 16.875 16.25V3.75C16.875 3.40482 16.5952 3.125 16.25 3.125Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.75 1.875V4.375" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M6.25 1.875V4.375" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M3.125 6.875H16.875" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Acceso ilimitado al curso
                 </div>
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-miterlimit="10"/>
  <path d="M2.5 10H17.5" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 17.2969C11.7259 17.2969 13.125 14.03 13.125 10C13.125 5.97005 11.7259 2.70312 10 2.70312C8.27411 2.70312 6.875 5.97005 6.875 10C6.875 14.03 8.27411 17.2969 10 17.2969Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-miterlimit="10"/>
</svg> Varios idiomas disponibles para un aprendizaje mejorado
                 </div>   
                    </div>
               
                 


                </div>
                <div className="Course_include forsmaller"  >
                    <div className="courseltitle" >
                    Qué va a aprender
                    </div>
                    <div className="coverspanish">
                       <div className="fortextinsider">
                       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 13.75C13.4518 13.75 16.25 10.9518 16.25 7.5C16.25 4.04822 13.4518 1.25 10 1.25C6.54822 1.25 3.75 4.04822 3.75 7.5C3.75 10.9518 6.54822 13.75 10 13.75Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 11.25C12.0711 11.25 13.75 9.57107 13.75 7.5C13.75 5.42893 12.0711 3.75 10 3.75C7.92893 3.75 6.25 5.42893 6.25 7.5C6.25 9.57107 7.92893 11.25 10 11.25Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13.75 12.5V18.75L10 16.875L6.25 18.75V12.5" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg>Carga instantánea al Portal TPR
                 </div>
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#6B6969" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M7.1875 9.375C7.70527 9.375 8.125 8.95527 8.125 8.4375C8.125 7.91973 7.70527 7.5 7.1875 7.5C6.66973 7.5 6.25 7.91973 6.25 8.4375C6.25 8.95527 6.66973 9.375 7.1875 9.375Z" fill="#6B6969"/>
  <path d="M12.8125 9.375C13.3303 9.375 13.75 8.95527 13.75 8.4375C13.75 7.91973 13.3303 7.5 12.8125 7.5C12.2947 7.5 11.875 7.91973 11.875 8.4375C11.875 8.95527 12.2947 9.375 12.8125 9.375Z" fill="#6B6969"/>
  <path d="M13.25 11.875C12.9196 12.4442 12.4455 12.9167 11.8751 13.2451C11.3048 13.5735 10.6582 13.7464 10 13.7464C9.34184 13.7464 8.69523 13.5735 8.12486 13.2451C7.5545 12.9167 7.0804 12.4442 6.75 11.875" stroke="#6B6969" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
</svg> Pase su CDL rápidamente ¡GARANTIZADO!
                 </div> 
                
                 <div className="fortextinsider">
                 <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
  <path d="M10 17.5C14.1421 17.5 17.5 14.1421 17.5 10C17.5 5.85786 14.1421 2.5 10 2.5C5.85786 2.5 2.5 5.85786 2.5 10C2.5 14.1421 5.85786 17.5 10 17.5Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-miterlimit="10"/>
  <path d="M2.5 10H17.5" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M10 17.2969C11.7259 17.2969 13.125 14.03 13.125 10C13.125 5.97005 11.7259 2.70312 10 2.70312C8.27411 2.70312 6.875 5.97005 6.875 10C6.875 14.03 8.27411 17.2969 10 17.2969Z" stroke="#2C292A" stroke-opacity="0.7" stroke-width="1.25" stroke-miterlimit="10"/>
</svg> Varios idiomas disponibles para un aprendizaje mejorado
                 </div>   
                    </div>
               
                 


                </div>
             
    </div>   
        <div className="containerofclassa mt-5 " >
        <div className="Graudatestudentjobs" style={{border:"none",background:"inherit"}}>
        <div className="courseltitle"style={{display:"flex",justifyContent:"center",width:"100%"}} >
        Empresas con las que trabajamos
                    </div>
                    <div className="describethestudent">
                    Los estudiantes que se graduaron con nosotros ahora están trabajando en estas empresas.                    </div>
                    <img className="sponsodeimage" src={allcomp} alt="all_companies"/>
                    </div>
        </div>
 
     </>
    )
}
export default LearningSectionSpanish;